// extracted by mini-css-extract-plugin
export default {"inputGroup":"inputGroup-QyKWf","input":"input-rBY9J","label":"label-Bcq2G"};